import React, { useState, useMemo, useContext } from "react";
import {
  swatchList, colorSwatch,
  selected, swatchLabel, swatchTitle, notSelectedColor
} from "./style.mod.scss";
import locale from "locales";
import VariantCategoryLevel from "./variant-category-level";
import * as style from "../pdp-variations/style.mod.scss";
import Link from "components/link";
import ProductContext from "services/product-context";

const ColorSwatchesCategory = (props) => {
  const { variants, currentVariant, hierarchy } = props;
  const [selectedColor, setSelectedColor] = useState(currentVariant?.swatchColor?.hex);
  const selectedCategory = currentVariant?.category?.parentCategory?.id;
  const parentCategory = currentVariant?.category?.parentCategory?.id;
  const { handle } = useContext(ProductContext);

  const filteredVariants = useMemo(() => {
    return variants.filter(variant => variant?.category?.parentCategory?.id === parentCategory);
  }, [variants, parentCategory]);

  const filteredProducts = filteredVariants?.filter(
    (product) =>
      product?.category?.parentCategory?.id === selectedCategory &&
      product?.swatchColor?.hex === selectedColor
  );

  const colors = [];
  for (let i = 0; i < filteredVariants?.length; i++) {
    const variant = filteredVariants[i];
    const color = variant?.swatchColor;
    const hex = color?.hex;

    if (!colors.some((c) => c?.hex === hex)) {
      const handle = variant?.handle?.current;

      colors.push({
        index: i, hex: hex, handle: handle
      });
    }
  }

  return <>
    <div className={swatchList}>
      <span className={swatchLabel}> <span className={swatchTitle}>{locale.products.colors}</span>: </span>
      {colors.map((color) => <div
        key={color?.index}
        className={`${selectedColor === color?.hex ? selected : notSelectedColor} `}>
        <Link to={`/products/${handle}/${color?.handle}`} onClick={() => setSelectedColor(color?.hex)} state={{ preserveScroll: true }}>
          <div className={colorSwatch} style={{ backgroundColor: color?.hex }}> </div>
        </Link>
      </div>)}
    </div>
    <div className={style.advancedProductGroup}>
      <VariantCategoryLevel
        categories={hierarchy}
        variants={variants}
        filteredProducts={filteredProducts}
        currentVariant={currentVariant} />
    </div>
  </>;
};

export default ColorSwatchesCategory;